var _excluded = ["name", "className", "size", "color"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "./index.less";
import "./style.css";
import classnames from 'classnames';
import React from 'react';
import { iconNameData } from "./coverData";
var sizeList = {
  small: 16,
  medium: 24,
  large: 32
};
var sizeAgent = new Proxy(sizeList, {
  get: function get(target, prop) {
    var _target$prop;
    return typeof prop === 'number' || !isNaN(Number(prop)) ? prop : (_target$prop = target === null || target === void 0 ? void 0 : target[prop]) !== null && _target$prop !== void 0 ? _target$prop : target === null || target === void 0 ? void 0 : target['small'];
  }
});
var renderMulti = function renderMulti(multiIcon, props) {
  var className = props.className,
    size = props.size;
  var iconClassName = classnames('iron-icon', _defineProperty({}, "icon-".concat(multiIcon.name), multiIcon.name), className);
  var fontSize = size ? "".concat(sizeAgent[size], "px") : '';
  return /*#__PURE__*/React.createElement("span", {
    className: iconClassName,
    style: {
      fontSize: fontSize
    },
    role: "img",
    "aria-label": multiIcon.name
  }, multiIcon.path && multiIcon.path.map(function (path) {
    return /*#__PURE__*/React.createElement("span", {
      className: path,
      key: path
    });
  }));
};
var Icon = function Icon(_ref) {
  var name = _ref.name,
    className = _ref.className,
    size = _ref.size,
    color = _ref.color,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var iconData = iconNameData();
  if (iconData.hasOwnProperty(name) && iconData[name].path) {
    return renderMulti(iconData[name], {
      className: className,
      size: size
    });
  }
  var iconClassName = classnames(className, 'iron-icon', _defineProperty({}, "icon-".concat(name), name));
  var singleColor = Array.isArray(color) ? '' : color;
  var fontSize = size ? "".concat(sizeAgent[size], "px") : '';
  return /*#__PURE__*/React.createElement("span", _extends({
    className: iconClassName,
    style: {
      color: singleColor,
      fontSize: fontSize
    },
    role: "img",
    "aria-label": name
  }, restProps));
};
export default Icon;